var map = {
	"./AbdulHayeeJatoi.jpeg": 2439,
	"./AishaJamal.jpeg": 4701,
	"./AliSaleem.jpeg": 9890,
	"./AmmaraManzoor.jpeg": 2749,
	"./AyeshaJamal.jpeg": 4690,
	"./IramManzoor.jpeg": 2541,
	"./JahanzaibKhaliq.jpeg": 4190,
	"./NabilaAsif.jpeg": 1204,
	"./NidaAnwar.jpeg": 9449,
	"./QurautainRizvi.jpeg": 2938,
	"./RabeeaMunawar.jpg": 4484,
	"./RabeeaMunawwar.jpeg": 2380,
	"./RameeshaKhalid.jpeg": 4039,
	"./SaimaSiddiqui.jpeg": 2689,
	"./ShafaqAbdulSamad.jpeg": 3016,
	"./ShenilaJawed.jpeg": 7831,
	"./TasneemFarzana.jpeg": 316,
	"./TasneemFarzana.jpg": 7107,
	"./UzmaHayat.jpeg": 4304,
	"./WaseemAhmed.jpg": 9026,
	"./WaseemShahani.jpeg": 478,
	"./ZaratulainBashir.jpeg": 1302,
	"./carousel1.png": 1760,
	"./carousel2.png": 7163,
	"./carousel2a.png": 3690,
	"./carousel3.png": 3506,
	"./carousel4.png": 6301,
	"./carousel5.png": 5172,
	"./defaultProfile.jpg": 9025,
	"./dna.png": 9412,
	"./female-avatar.jpg": 2081,
	"./lock.png": 3558,
	"./logo.png": 2806,
	"./male-avatar.jpg": 2876,
	"./mapImage.png": 1642,
	"./mapImage1.png": 3513,
	"./nibd-hyd.png": 838,
	"./nibd-khi.png": 9807,
	"./nibd-lhr.png": 5803,
	"./nibd-skr.png": 8597,
	"./njhs-logo.png": 1410,
	"./pdf.png": 1577,
	"./pendingCases.png": 7431,
	"./popup-mini.png": 2173,
	"./popup.png": 253,
	"./popup1.png": 6480,
	"./profile.jpg": 1120,
	"./profile.png": 5572,
	"./profile.webp": 4250,
	"./shape-bg.png": 6162,
	"./short-logo.png": 6253,
	"./totalReferralCase.png": 9526,
	"./word.png": 4931
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;